<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="update-project-lead-user-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Update Assignee
            </h4>
          </div>

          <div class="modal-body">
            <SelectFormGroup
                v-model="user"
                name="user"
                label="User"
                :options="userOptions"
                :nullable="true"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'

export default {
  components: {SelectFormGroup},

  props: {
    selected: {
      type: Array
    },

    users: {
      type: Array
    },
  },

  data() {
    return {
      user: null
    }
  },

  mounted() {
    this.listenForClose()
  },

  computed: {
    userOptions() {
      return this.users.map(user => {
        return {
          value: user.id,
          label: user.attributes.full_name
        }
      })
    }
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      this.errors = {}

      Promise
          .all(this.selected.map(projectLead => http.put('/api/v2/project-leads/' + projectLead.id, {...projectLead.attributes, user_id: this.user}).catch(() => {
          })))
          .then(responses => {
            notify.success('The user was updated')

            this.$emit('updated', responses.map(response => response.data.data))

            $(this.$el).modal('hide')
          })
    },

    reset() {
      this.errors = {}

      this.user = null
    }
  }
}
</script>
